var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"min-width":"100%"}},[_c('plan-pagos-details',{ref:"refPlaPagosDetail"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }